import VueScrollTo from 'vue-scrollto';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('scroll-to', VueScrollTo);

  nuxtApp.vueApp.directive('focus', {
    beforeMount(el) {
      el._mouseHandler = function () {
        el.style.outline = 'none';
      };
      el._keyHandler = function () {
        el.style.outline = '';
        el.focus();
      };
      window.addEventListener('mousedown', el._mouseHandler, {
        passive: true
      });
      el.addEventListener('keyup', el._keyHandler, {
        passive: true
      });
    },
    unmounted(el) {
      window.removeEventListener('mousedown', el._mouseHandler);
      el.removeEventListener('keyup', el._keyHandler);
    }
  });
})